import { GlobalToken, theme } from 'antd'
import { CSSInterpolation } from '@ant-design/cssinjs'

export const genLayoutStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => {
  // const a = theme.getDesignToken()
  // console.log('token', JSON.stringify(token))
  return [
    {
      [`.${prefixCls}`]: {
        height: '100%',
        [`.layout`]: {
          background: token.colorBgLayout,
          transition: 'margin 300ms',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          [`.header`]: {
            position: `sticky`,
            top: `0`,
            display: `flex`,
            padding: `24px 34px`,
            alignItems: `center`,
            gap: `14px`,
            borderBottom: `1px solid rgba(0, 0, 0, 0.05)`,
            background: `#FFF`,
            zIndex: '9',
            justifyContent: 'space-between',
            [`.menuleft`]: {
              display: 'flex!important',
              gap: '10px',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'center',
              [`.title`]: {
                color: `#000`,
                fontSize: `34px`,
                fontWeight: `600`,
              },
            },

            [`.menuright`]: {
              // position: 'absolute',
              // right: '0',
              height: '100%',
              display: 'flex',
              alignItems: 'center',
              padding: '0 34px',
              fontWeight: 700,
              cursor: 'pointer',
              gap: '20px',
              [`.menurightButton`]: {
                fontSize: `16px`,
                color: 'black',
                textDecoration: 'none',
                // ['&:hover']: {
                //   color: '#7890fa',
                // },
              },
              [`.menurightButton.active`]: {
                color: '#7890fa',
              },
            },
          },

          [`.content`]: {
            minHeight: '80%',
            margin: '16px',
            background: '#fff',
            flex: '1',
          },
          [`.footer`]: {
            height: `60px`,
            textAlign: `center`,
            display: `flex`,
            justifyContent: `center`,
            flexDirection: `column`,
            gap: `8px`,
            [`.footerLinks`]: {
              display: `flex`,
              gap: `12px`,
              justifyContent: `center`,

              [`.footerLinksItem`]: {
                color: '#4C65ED',
                cursor: 'pointer',
                [` &:hover`]: {
                  color: '#7890fa',
                },
              },
            },
            [`.copyright`]: {
              fontSize: `12px`,
              color: `#999`,
            },
          },
        },
      },
    },
  ]
}

export const genUserInfoStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => [
  {
    [`.${prefixCls}`]: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      borderRadius: '100px',
      background: '#FFF0F0',
      padding: '8px 12px',
      cursor: 'pointer',
      color: '#0D1121',
      fontSize: 12,
      fontWeight: 500,
    },
  },
]

export const genUserInfoMenuItemStyle = (
  prefixCls: string,
  token: GlobalToken
): CSSInterpolation => [
  {
    [`.${prefixCls}`]: {
      backgroundColor: '#FFFFFF',
      padding: '24px',
      borderRadius: '4px',
      boxShadow: '0px 0px 4px 0px #DFE9FA, 0px 4px 8px 0px #6D86A31A',
      display: 'flex',
      flexDirection: 'column',
      gap: '16px',
      '.user-info-all': {
        display: 'flex',
        flexDirection: 'column',
        gap: '6px',
        [`.user-info`]: {
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end',
          justifyContent: 'flex-start',
          gap: '8px',
          ['.org-path-name']: {
            fontSize: '14px',
            fontWeight: 500,
            color: '#3D414D',
          },
          [`.user-name`]: {
            fontSize: '18px',
            fontWeight: 500,
            color: '#0D1121',
          },
          [`.user-post-name, .user-phone`]: {
            fontSize: '12px',
            fontWeight: 400,
            color: '#6E707A',
          },
        },
      },
    },
  },
]
